import { mergeStyles } from '@fluentui/react';

const maxDividendAllowedStyle = mergeStyles({
  width: '295px',
});

export default maxDividendAllowedStyle;
